import {
  BROWSER_IMAGE_ACCEPT,
  BROWSER_IMAGE_FORMAT_LABEL,
  isSupportedBrowserImage,
} from "./browserImageUploadPolicy";

export const REFERENCE_IMAGE_MAX_COUNT = 3;
export const REFERENCE_IMAGE_MAX_INPUT_BYTES = 5 * 1024 * 1024;
export const REFERENCE_IMAGE_PREPARED_MAX_MB = 0.3;
export const REFERENCE_IMAGE_PREPARED_MAX_BYTES = 350_000;
export const REFERENCE_IMAGE_DATA_URL_MAX_LENGTH = 470_000;

export const REFERENCE_IMAGE_FORMAT_LABEL = BROWSER_IMAGE_FORMAT_LABEL;
export const REFERENCE_IMAGE_ACCEPT = BROWSER_IMAGE_ACCEPT;

/**
 * These are the formats supported by the complete create flow: browser
 * preview/normalization, storage, and Gemini image input. Gemini also accepts
 * HEIC/HEIF, but browsers cannot reliably decode those files for the preview
 * and compression step without an additional converter.
 */
export function isSupportedReferenceImage(
  file: Pick<File, "name" | "type">
): boolean {
  return isSupportedBrowserImage(file);
}
